module.exports = __webpack_public_path__ + "b47919c5b3debce836897092904a66d5.png";